import { useLanguage } from "../../context/LanguageContext";

interface NoDataProps {
  title?: string;
  message?: string;
  imageSrc?: string;
  mainClassName?: string;
  subClassName?: string;
  classHeading?:string;
  classParagraph?:string;

}

const NoDataFound: React.FC<NoDataProps> = ({
  title = "No Data Found",
  message = "Try adjusting your filters or come back later.",
  imageSrc = "/img/data-not-found.png",
  mainClassName = "bg-[#F7F6F2] pt-2 rounded-r-3xl rounded-b-3xl",
  subClassName = "bg-[#FCFDF8]",
  classHeading = "text-[#212121]",
  classParagraph = "text-[#212121]/70",
}) => {
  const { t } = useLanguage();
  return (
    <div className={` ${mainClassName}`}>
      <div className={`${subClassName} rounded-b-3xl rounded-r-3xl flex flex-col items-center justify-center text-center py-12 text-gray-500`}>
        <img src={imageSrc} alt="No Data" className="w-24 h-24 mb-4" />
        <h3 className={`text-2xl font-semibold ${classHeading}`}>{t(title)}</h3>
        <p className={`text-base ${classParagraph} mt-1`}>{t(message)}</p>
      </div>
    </div>
  );
};

export default NoDataFound;
